import { css } from "@emotion/css"
import styled from "@emotion/styled"
import type { ComponentProps } from "react"
import { ORANGE_COLOR } from "theme/colors"
import Button from "./Button"

const StyledTextButton = styled(Button)<{ color?: string }>`
  color: ${(p) => p.color || ORANGE_COLOR};
  padding: 0;
  font-weight: 700;
  display: inline-flex;
  gap: 5px;
  line-height: inherit;
  align-items: center;
  text-decoration: none;
`

function TextButton({
  type = "button",
  ...props
}: ComponentProps<typeof StyledTextButton>) {
  return <StyledTextButton type={type} {...props} />
}

export default TextButton
